import { useEffect } from "react";
// import { useLocation } from "react-router-dom";

const ScrollToTop = (props) => {
    // const location = useLocation();
    useEffect(() => {
      // Immediately scroll to top without smooth behavior for faster loading
      window.scrollTo({top: 0, left: 0, behavior: 'auto' });
    }, []);
  
    return <>
        {props.children}
    </>
  };

export default ScrollToTop;
